import { render, staticRenderFns } from "./single-language-text-field.vue?vue&type=template&id=a2253578&scoped=true&"
import script from "./single-language-text-field.vue?vue&type=script&lang=js&"
export * from "./single-language-text-field.vue?vue&type=script&lang=js&"
import style0 from "./single-language-text-field.vue?vue&type=style&index=0&id=a2253578&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2253578",
  null
  
)

export default component.exports